var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column",class:{ellipsis: _vm.ellipsis, center: _vm.center},style:(`grid-column: ${_vm.span} span`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }